<template>
  <v-tabs

    class="imd-sm-tabs"
    height="33"

    v-bind="$attrs"
    v-on="$listeners">

    <slot></slot>
  </v-tabs>
</template>

<style>
.imd-sm-tabs .v-tab { font-size: 12px; }
</style>

<script>
export default {
  inheritAttrs: false,
  model: {
    prop: 'input',
    event: 'change'
  },

}
</script>
